// removed by extract-text-webpack-plugin
module.exports = {"reviewResponse":"src-components-sitewide-Reviews-__review-response__reviewResponse--jHJFD","responseIcon":"src-components-sitewide-Reviews-__review-response__responseIcon--3Nhjk","commentIcon":"src-components-sitewide-Reviews-__review-response__commentIcon--2xAK8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sitewide/Reviews/review-response.css
// module id = 2009
// module chunks = 0